import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import {
  Section,
  SectionItem,
  SectionLink,
  SectionName,
} from '../components/Chrome';
import { useToast } from '../components/Toast';
import Icon from '../components/Icon';
import { SPACE, VIEWER } from '../utilities/queries';
import { useSpaceContext } from '../contexts/space';
import { CREATE_PORTAL_SESSION } from '../utilities/mutations';

const SpaceSettingsPlanPage = () => {
  const params = useParams();
  const toast = useToast();
  const { spaceVars } = useSpaceContext();
  const { data: spaceData, loading: spaceLoading } = useQuery(SPACE, {
    variables: { slug: params.s, ...spaceVars },
  });
  const { data: viewerData, loading: viewerLoading } = useQuery(VIEWER);
  const [loading, setLoading] = useState(false);
  const [createPortalSession] = useMutation(CREATE_PORTAL_SESSION, {
    variables: { spaceSlug: params.s },
  });

  const planLevel = () => {
    let val;

    switch (spaceData.space.planLevel) {
      case 0:
        val = 'Free';
        break;
      case 1:
        val = 'Plus';
        break;
      case 2:
        val = 'Testing';
        break;
      default:
        val = 'Unknown';
    }

    return val;
  };

  return (
    <>
      <Helmet>
        <title>Plan</title>
      </Helmet>
      <Section>
        <SectionName isSecondLevel>Plan</SectionName>
        {!spaceLoading && !viewerLoading && (
          <>
            <SectionItem>You are on the {planLevel()} plan.</SectionItem>
            {spaceData.space.ownerId !== viewerData.viewer.id && (
              <>
                <SectionItem isBlock />
                <SectionItem>
                  Only the space owner can manage billing.
                </SectionItem>
              </>
            )}
            {spaceData.space.planLevel === 0 &&
              spaceData.space.ownerId === viewerData.viewer.id && (
                <>
                  <SectionItem isBlock />
                  <SectionLink to="upgrade">
                    Upgrade
                    <Icon name="arrow-right" />
                  </SectionLink>
                </>
              )}
            {spaceData.space.planLevel === 1 &&
              spaceData.space.ownerId === viewerData.viewer.id &&
              spaceData.space.customer && (
                <>
                  <SectionItem isBlock />
                  <SectionLink
                    as="button"
                    disabled={loading}
                    onClick={async () => {
                      try {
                        setLoading(true);

                        const data = await createPortalSession();

                        window.location.replace(data.data.createPortalSession);

                        setLoading(false);
                      } catch (error) {
                        setLoading(false);

                        toast({ children: error.message });
                      }
                    }}
                  >
                    Edit billing
                    <Icon name="arrow-right" />
                  </SectionLink>
                </>
              )}
          </>
        )}
      </Section>
      {!spaceLoading &&
        !viewerLoading &&
        spaceData.space.ownerId === viewerData.viewer.id &&
        spaceData.space.planLevel <= 0 && <Outlet />}
    </>
  );
};

export default SpaceSettingsPlanPage;
